import { render, staticRenderFns } from "./inquiry-tab.vue?vue&type=template&id=7dc897b3"
import script from "./inquiry-tab.vue?vue&type=script&lang=js"
export * from "./inquiry-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports